'use strict'

cpntMap.set('awe-collapser', {
  props: {
    scroll: {type: Boolean, default: false}
  },
  data: function(){
    return {
      i18n: this.$root.i18n,
      open: false
    }
  },
  computed: {
    label: function(){
      return this.open ? 'READ_LESS' : 'READ_MORE'
    }
  },
  methods: {
  },
  template: `
  <div class="collapser" v-bind:class="{open, scroll}">
    <slot></slot>

    <button class="toggle" v-on:click="open=!open"
      :aria-label="i18n.getString(label)">
      {{i18n.getString(label)}}
    </button>
  </div>
  `
})
